import { render, staticRenderFns } from "./UploadCropper.vue?vue&type=template&id=635e28b8&"
import script from "./UploadCropper.vue?vue&type=script&lang=js&"
export * from "./UploadCropper.vue?vue&type=script&lang=js&"
import style0 from "./UploadCropper.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports